import React, { useEffect, useState } from "react";
import API from "libs/api";
import { useParams } from "react-router-dom";
import TABLE from "components/cmp_table/cmp_table";



export default function TAB_PAGES({ current_tab }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    //  data table variables
    const [ var_data, set_data ] = useState([]);
    const [ var_data_settings, set_data_settings ] = useState({
        limit: 15,
        offset: 0,
        totalrows: 0,
        search: '',
        sortby: 'url',
        sortorder: 'asc'
    });
    const [ var_totalrows, set_totalrows ] = useState(0);

    //  data ready variables
    const [ var_ready, set_ready ] = useState(false);
    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (current_tab === 'PAGES' && provider_id) {
            get_pages(var_data_settings);
        }
    }, [ current_tab, provider_id ]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_pages(data_settings){

        set_ready(false);
        set_processing('processing');

        //  use current data settings if none are submitted
        data_settings && set_data_settings(data_settings);
        let settings = data_settings || var_data_settings;

        try {
            let results = await API_get_pages(settings);

            //  set totalrows
            set_totalrows(results.totalrows);

            //  set data
            set_data(results.results === undefined ? [] : results.results);

            set_processing('inactive');
            set_ready(true);
        } catch (e) {
            set_processing('error');
        }

    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_pages(settings){
        let var_parameters = {queryStringParameters: settings};
        return API.get('admin-providers', '/get-pages/' + provider_id, var_parameters);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    // function onClick_create(){
    //     set_location_create_open(true);
    // }

    function onClick_page(){

    }



    // RENDER CONTAINER ================================================================================================

    return (
        <div id='tab__page--provider_tags' className='tab__page tab__transition'>

            <div className='card pages'>
                <div className='card__header'>
                    <div className='card__header__title_totalrows'>
                        <div className='text--md bold'>Provider pages</div>
                        <div className='card__header__totalrows text--md normal'>{var_totalrows.toLocaleString()}</div>
                    </div>
                </div>
                <div className='card__content'>

                    <TABLE
                        var_data_settings={var_data_settings}
                        set_data_settings={set_data_settings}
                        onChange={get_pages}
                        processing={var_processing}
                        totalrows={var_totalrows}
                    >
                        <headers>
                            <header sortby='url'>URL</header>
                            <header sortby='page_level' width='112px'>Page level</header>
                            <header sortby='status' width='224px'>Status</header>
                            <header sortby='lastmodified' width='192px'>Modified</header>
                        </headers>
                        <data>
                            {var_data.map(item =>
                                <row key={item.id} onClick={()=>onClick_page(item)}>
                                    <cell>{item.url}</cell>
                                    <cell>{item.page_level}</cell>
                                    <cell>{item.status}</cell>
                                    <cell>{item.lastmodified}</cell>
                                </row>
                            )}
                        </data>
                    </TABLE>

                </div>
            </div>
        </div>
    );
}
